export const enum DtoState {
	Exists = 0,
	New = 1,
	Deleting = 2,
	Deleted = 3,
	Empty = 100,
	ReadOnly = 200
}

export enum IconSize {
	Exact16 = "Exact16",
	Preferred16 = "Preferred16",
	Exact24 = "Exact24",
	Preferred24 = "Preferred24",
	Exact32 = "Exact32",
	Preferred32 = "Preferred32",
	Exact48 = "Exact48",
	Preferred48 = "Preferred48",
	ExactSpecial = "ExactSpecial",
	PreferredSpecial = "PreferredSpecial"
}

export const enum LogonResult {
	Failed,
	Succeeded,
	PasswordExpired,
	MarketerAccessDenied
}

export const enum DayOfWeek {
	Monday = 1,
	Tuesday = 2,
	Wednesday = 3,
	Thursday = 4,
	Friday = 5,
	Saturday = 6,
	Sunday = 0
}

export const enum SqafIconId {
	CFlight = 10183,
	CFlightTv = 10184
}

export const enum SqafFunctionPermissionId {
	None = 0,
	UaUserAccountRead = 1000,
	UaUserAccountAdmin = 1005,
	UaLoginAdmin = 1010,
	UaContactAdmin = 1020,
	UaFunctionAdmin = 1030,
	UaUserPermissions = 1040,
	UaPackageRead = 1050,
	UaPackageAdmin = 1060,
	ExecuteUserManagement = 1101,
	ExecutePermissionManagement = 1102,
	ExecuteOwnStartscreenManagement = 7510,
	ExecuteUaStartscreenManagement = 7520,
	ClearCache = 7560,
	ExecuteInventoryManagement = 1201,
	ExecuteAdvertisingTypeManagement = 1202,
	ExecutePriceListManagement = 1203,
	ExecuteOrganisationManagement = 1301,
	ExecuteMarketerManagement = 1302,
	ExecuteMandatorManagement = 1303,
	ExecuteRepresentativeManagement = 1304,
	ExecuteCampaignManagement = 1401,
	ExecuteReportManagement = 1402,
	ExecuteXmediaCampaignManagement = 1403,
	ExecuteProtocols = 1500,
	ExecuteBlacklistManagement = 1601,
	ExecuteMandatorAccounting = 1801,
	ExecuteAccountingPeriodManagement = 1802,
	ExecuteVerticalEwl = 1803,
	ExecutePublisherAccounting = 1804,
	ExecuteRepresentativeAccounting = 1811,
	ExecuteAgencyAccouting = 1812,
	ExecuteReporting = 1901,
	ExecuteDashboard = 1902,
	ExecuteDiscountAnalysis = 1903,
	CustRead = 2000,
	CustUpdate = 2010,
	CustApprove = 2011,
	CustInsert = 2020,
	CustDelete = 2030,
	CustAdressInsert = 2040,
	CustAdressDelete = 2050,
	CustPersonInsert = 2060,
	CustPersonDelete = 2070,
	CustRelationUpdate = 2080,
	CustAgreementRead = 2090,
	CustAgreementWrite = 2100,
	CustAgreementEditDiscountGroups = 2101,
	CustAgreementVolumeWrite = 2110,
	CustAgcontractsRead = 2200,
	CustAgcontractsUpdate = 2210,
	CustCrmAccess = 2220,
	CustClassAccess = 2230,
	CustAgreementEditPaymentTerm = 2260,
	CustResponsibilitiesUpdate = 2270,
	CustAdserverUpdate = 2280,
	IvRead = 2500,
	IvUpdate = 2510,
	IvInsert = 2520,
	IvDelete = 2530,
	IvAdminExclusiveBlocks = 2540,
	AtRead = 2600,
	AtUpdate = 2610,
	AtInsert = 2620,
	AtDelete = 2630,
	PlRead = 2700,
	PlUpdate = 2710,
	PlInsert = 2720,
	PlDelete = 2730,
	CpgEditVolumeDiscount = 2900,
	CpgEditInvoicedInstallment = 2910,
	CpgPrpOverviewRead = 3000,
	CpgPrpRead = 3010,
	CpgPrpCreate = 3020,
	CpgPrpUpdate = 3030,
	CpgPrpCreatePrpVersion = 3040,
	CpgPrpCreateOrdVersion = 3041,
	CpgPrpCreateDoc = 3050,
	CpgPrpGrant = 3060,
	CgpPrpCreateOrd = 3070,
	CpgPrpShift = 3080,
	CpgPrpChangeSalesRepresentatives = 3090,
	CpgOrdOverviewRead = 3100,
	CpgOrdRead = 3110,
	CpgOrdCreate = 3120,
	CpgOrdUpdate = 3130,
	CpgOrdCreatePrpVersion = 3140,
	CpgOrdCreateOrdVersion = 3141,
	CpgOrdCreateDoc = 3150,
	CpgOrdCreateAccountingDocument = 3151,
	CpgOrdCreateAccountingDocumentBatch = 3152,
	CpgOrdViewAccountingDocument = 3153,
	CpgOrdCheckInstallment = 3154,
	CpgOrdShift = 3180,
	CpgOrdEditManualDeliveries = 3182,
	CpgOrdManageClosingState = 3183,
	CpgOrdEditAgencyPaybackCapability = 3184,
	CpgOrdEditCreditorProperties = 3185,
	CpgOrdViewDocumentProperties = 3186,
	CpgOrdEditDocumentProperties = 3187,
	CpgOrdChangeSalesRepresentatives = 3188,
	CpgPaymentReceiptCreate = 3190,
	CpgOrdCancelAccountingDocument = 3191,
	CancelDebExternalInvoiceSingle = 3420,
	CancelDebExternalInvoiceMultiple = 3421,
	CancelDebInternalInvoiceSingle = 3422,
	CancelDebInternalInvoiceMultiple = 3423,
	CpgLineitemPricingWrite = 3196,
	CpgAlterDynamicAllocation = 3197,
	CpgLineitemPrpShareRemove = 3198,
	CpgPrpOfferedToProcessingStatusTransition = 3280,
	CpgPrpCustomerAcceptedToOfferedStatusTransition = 3281,
	CpgOrdConfirmedToProcessingStatusTransition = 3290,
	CpgOrdDeliveryCanceledToProcessingStatusTransition = 3291,
	CpgOrdLinkToAdserver = 3298,
	SptcliRead = 3300,
	SptcliUpdate = 3310,
	SptcliUpdateCm = 3311,
	SptcliUpdatePriority = 3312,
	CpgOrderSptcliUpdateSpecialGam360 = 3313,
	CpgProposalSptcliUpdateSpecialGam360 = 3314,
	CpgProposalSptcliUpdateSpecialAdition = 3315,
	CpgOrderSptcliUpdateSpecialAdition = 3316,

	CpgDfpInitialRead = 3330,
	CpgDfpInitialUpdate = 3331,
	CpgDiscountsApprove = 3335,
	CpgPrpCreateOrd = 3401,
	CpgOrdCreateOrd = 3403,
	CpgLineitemImportWrite = 3404,
	CpgClearingDocument = 3405,
	CpgOrdEditCpmngtChecked = 3407,
	CpgOrdValiditycheckEdit = 3409,

	CpgLineitemUpdateAmsp = 3412,
	CpgSendAdvertisingMediaReminder = 3413,

	DebEditDocumentProperties = 3424,

	MdtRead = 3500,
	MdtUpdate = 3510,
	MdtApprove = 3511,
	MdtInsert = 3520,
	MdtDelete = 3530,
	MdtActivateContracts = 3540,
	MdtDeactivateContracts = 3541,
	MdtCsEdit = 3542,
	MdtCsUpdate = 3543,
	MdtContractsRead = 3580,
	MdtSpexToolUpdate = 3560,
	MdtContractsWrite = 3590,
	MktRead = 4000,
	MktUpdate = 4010,
	ProtocolBrowser = 4200,
	KillUserProcesses = 4250,
	UtCreateTasks = 5010,
	UtReadOtherTasks = 5020,
	UtUpdateOtherTasks = 5030,
	UtAdministrator = 5040,
	UtReadAllTasks = 5050,
	BlRead = 5500,
	BlAdministrator = 5510,
	AsiQueryAvails = 6010,
	AsiSyncCampaign = 6020,
	AsiChangeQueueOrder = 6030,
	AsiCancelAllJobs = 6040,
	ManageJobPriority = 6050,
	MacRead = 8000,
	MacUpdate = 8010,
	MacViewDocuments = 8011, //Belege anzeigen
	MacPerformSettlement = 8020,
	MacApproveRevenueShare = 8021,
	MacCreateDocuments = 8022, //Belege Erstellen
	MacRecreateDocuments = 8023, //Belege (neu) erstellen
	MacClosePeriod = 8024,
	MacEditDocumentProperties = 8025,
	MacCancelCalculations = 8026,
	MacCreateList = 8028, //Rechnungs-/Auftragsliste erstellen
	MacManageMarketerSettlements = 8029, //Vermarkter Abschlüsse verwalten
	MacSearchDocuments = 8031, //Publisher Beleg suchen
	RptRead = 9000,
	RptReadMandatorlist = 9001,
	RptReadSales = 9002,
	RptAdministrator = 9010,
	RptReadFinance = 9011,
	XmediaRead = 9100,
	XmediaAdministrator = 9110,
	FpChangeLedgerPeriod = 9202,
	ConfigurationUpdate = 12000,
	ConfigurationRead = 12010,
	CpgSchedulerOpen = 3408
}

export const enum InventoryType {
	Simple = 1,
	Package = 2
}

export const enum AdvertisingStructureType {
	Simple = 1,
	Bundle = 2,
	MasterCompanion = 3,
	Compound = 4
}

export const enum AdvertisingTypeProperty {
	ImmediateBookable = 1,
	SignOffRequired = 2,
	VideoAd = 4,
	Exclusive = 8,
	BookableInPackageOnly = 16,
	IABAdvertisingType = 32,
	NotCreatesVolume = 64,
	NotDiscountable = 128,
	NotAECommisionable = 256
}

export const enum CampaignLineItemTypeId {
	Regular = 10,
	DependentBonusPos = 20,
	IndependentBonusPos = 30,
	BonusPosAddon = 35,
	Addon = 40,
	Package = 50,
	PackageSubItem = 60,
	PackageBonuspos = 65,
	Service = 70,
	PrivateDeal = 80,
	Auction = 90,
	CFlight = 100,
	CFlightTv = 101,
	CFlightDigital = 102,
}

export const enum AccountingStatusId {
	None = 0,
	PartialInvoiced = 1,
	TotallyInvoice = 2,
}

export const enum ServerElementType {
	None = 0,
	Dfp5AdType = 1,
	Dfp5CreativeType = 2,
	Dfp5TimePeriod = 3,
	Dfp5ContentCategory = 4,
	Dfp5Site = 5,
	Dfp5Zone = 6,
	Dfp5PriceType = 7,
	Dfp5ProductType = 8,
	Dfp5KeywordTargeting = 9,
	Dfp5PackThemeTargeting = 10,
	Dfp5ScheduleType = 11,
	Dfp5VideoPosition = 12,
	Dfp5UserRole = 13,
	Dfp5User = 14,
	DfpLabel = 15,
	DfpPositionTargetingKey = 16,
	DfpPositionTargetingValue = 17,
	ManualSite = 20,
	SmartSite = 21,
	SmartPage = 22,
	DartEnterpriseSite = 23,
	DartEnterpriseZone = 24,
	SmartPack = 25,
	SmartFormatType = 26,
	SmartInsertionType = 27,
	SmartKeyword = 28,
	SmartGroupCapping = 29,
	SmartInsertionPriority = 30,
	SmartInsertionProperties = 31,
	SmartFcTimeunit = 32,
	SmartGeoTargeting = 33,
	DfpUser = 43,
	DfpRole = 44,
	DfpTeam = 45,
	DfpOrderStatus = 50,
	DfpDeliveryRateType = 53,
	DfpRoadblockingType = 54,
	DfpTimeUnit = 55,
	DfpLineitemType = 56,
	DfpComputedStatus = 65,
	DfpPostalCode = 76,
	DfpPublisherTag = 77,
	DfpAudienceSegment = 78,
	DfpConsentEligibility = 79,
	DfpContentBundle = 80,
	AdtechSite = 81,
	AdtechPage = 82,
	AdtechPlacementType = 83,
	AdtechPlacementPosition = 84,
	AdtechDisplaySize = 85,
	AdtechVideoSize = 86,
	AdtechCampaignType = 87,
	AdtechCampaignPriority = 88,
	AdtechPageCategory = 89,
	AdtechBookingType = 90,
	AdtechPaymentType = 91,
	AdtechCustomerType = 92,
	AdtechDailyDistribution = 93,
	AdtechTimeframeDistribution = 94,
	AdtechExclusiveType = 95,
	AdtechFcPeriodType = 96,
	AdtechCampaignStatus = 97,
	DfpAudienceSegmentGroup = 98,
	DfpLineItemStartType = 111,
}

export const enum CampaignLineItemPropertyInternId {
	None = 0,
	AdvertiserFromDeliveryLog = 1,
	AdvertisingTypeFromDeliveryLog = 2
}

export const enum KeyValueTargetingGroupId {
	Standard = 1,
	LearningTags = 2,
	FreeWheelAudienceSegments = 3,
	AditionAudienceSegments = 4
}

export const enum SqafSimpleSignOffState {
	NotChecked = 1,
	Granted = 2,
	Denied = 4
}

export const enum SqafLanguageId {
	DEU = 1031,
	ENU = 1033,
	FRA = 1036,
	ITA = 1040
}

export const enum SqafClassId {
	None = 0,
	TestObject = 99,
	DataFile = 100,
	FunctionPermissionpackage = 101,
	FunctionPermissiontopackage = 102,
	Protocol = 103,
	Responsibility = 104,
	Setting = 105,
	UserAccount = 106,
	UserContact = 107,
	UserLogin = 108,
	UserPermissionAssignment = 109,
	UserPermissionAssignmentException = 110,
	UserroleAssignment = 111,
	UserSubstitution = 112,
	VsApplication = 113,
	VsCondition = 114,
	VsCountry = 115,
	VsCurrency = 116,
	VsFunctionPermission = 117,
	VsFunctionPermissionAccess = 118,
	VsFunctionPermissionType = 119,
	VsIcon = 120,
	VsLanguage = 121,
	VsModule = 122,
	VsModulegroup = 123,
	VsPermissionContext = 124,
	VsPermissionContexttype = 125,
	VsProtocolItemType = 126,
	VsSystem = 127,
	VsTitle = 128,
	VsUserAccountStatus = 129,
	VsUserAccountType = 130,
	VsUserContactType = 131,
	VsUserLoginType = 132,
	VsUserrole = 133,
	RemarkContext = 134,
	Remark = 135,
	HistoryEvent = 136,
	History = 137,
	UserTask = 138,
	Mail = 139,
	ForeignClass = 140,
	Queue = 149,
	QueueGroup = 150,
	QueueProcessingStatus = 151,
	QueueResultStatus = 152,
	QueueOperationType = 153,
	SlotStatus = 154,
	SimpleSignoffState = 155,
	Organisation = 2001,
	OrgCustomer = 2002,
	OrgMandator = 2003,
	OrgMarketer = 2004,
	OrgAdvertiser = 2005,
	OrgParentAdvertiser = 2006,
	OrgAgency = 2007,
	OrgParentAgency = 2008,
	OrgMainAgency = 2009,
	OrgRepresentative = 2010,
	OrganisationType = 2011,
	OrganisationRelationType = 2012,
	OrganisationRelation = 2013,
	OrganisationProperty = 2014,
	Product = 2015,
	ProductClass = 2016,
	ProductClassLevel = 2017,
	DocumentType = 2018,
	PersonProperty = 2019,
	Person = 2020,
	AddressProperty = 2021,
	Address = 2022,
	PaymentTerm = 2023,
	PaymentPlan = 2024,
	DiscountAgreementProperty = 2025,
	AgencyContract = 2026,
	VolumeOrigin = 2027,
	DiscountScale = 2028,
	DiscountAgreement = 2029,
	DiscountRate = 2030,
	OrganisationToDiscountAgreement = 2031,
	BusinessSegment = 2032,
	MandatorContract = 2033,
	AccountingPeriod = 2036,
	DiscountVolume = 2037,
	SettlementType = 2038,
	DiscountGradation = 2044,
	SalesOffice = 2045,
	SalesOfficeProperty = 2046,
	VolumeBase = 2047,
	DiscountScaleProperty = 2048,
	Campaign = 2050,
	CpgSalesRequest = 2051,
	CpgSalesProposal = 2052,
	CpgSalesOrder = 2053,
	CpgProgrammaticSalesProposal = 4043,
	CpgProgrammaticSalesOrder = 4044,
	CampaignType = 2054,
	CampaignStatus = 2055,
	TechnicalSite = 2056,
	TechnicalZone = 2057,
	CommercialSite = 2058,
	Pricing = 2059,
	SettlementMethod = 2060,
	CampaignPropertyExtern = 2061,
	CampaignPropertyIntern = 2062,
	CampaignRelationType = 2063,
	CampaignRelation = 2064,
	CustomerToCampaignConfig = 2065,
	CustomerRole = 2066,
	CustomerToCampaign = 2067,
	CustomerToCampaignDocument = 2068,
	CampaignLineItem = 2069,
	CampaignLineItemType = 2070,
	CampaignLineItemProperty = 2071,
	Discount = 2073,
	DiscountValue = 2074,
	Surcharge = 2076,
	SurchargeType = 2077,
	SubtotalType = 2079,
	SubtotalTypeProperty = 2080,
	Document = 2081,
	DocumentLineitem = 2082,
	DocumentConfiguration = 2083,
	CampaignInstallment = 2085,
	ExclusiveBookingBlock = 2088,
	Report = 2090,
	AdvertisingType = 2102,
	Inventory = 2106,
	PriceGroup = 2107,
	PriceList = 2112,
	PriceListItem = 2114,
	TechnicalExclusion = 2120,
	Serverinstance = 2132,
	ServerElement = 2133,
	InventoryToAdvertisingType = 2135,
	AdvertisingTypeClass = 2150,
	AdvertisingTypeStructure = 2151,
	InventoryCategory = 2152,
	SetOfSites = 2153,
	SiAgentur = 3000,
	SiKunde = 3001,
	SiMandant = 3002,
	SiSite = 3003,
	SiAgenturAdresse = 3010,
	SiKundeAdresse = 3011,
	SiMandantAdresse = 3012,
	SiAgenturPerson = 3020,
	SiKundePerson = 3021,
	SiMandantPerson = 3022,
	SalesRepresentativeContract = 3301,
	ProfitShare = 4003,
	PeriodSettlementDetail = 4010,
	RevenueObject = 4020,
	RevenueLineItem = 4021,
	RevenueProfitShare = 4022,
	PublisherSettlement = 4030,
	PublisherSettlementToProfitShare = 4031,
	CpgSolutionsOrder = 4048,
	Dbcfm = 4100
}

export const enum ModuleId {
	Nemo = 20,
	PermissionManagement = 102,
	ControllingInformationCenter = 103,
	InventoryManagement = 201,
	AdvertisingTypeManagement = 202,
	PriceListManagement = 203,
	OrganisationManagement = 301,
	MarketerManagement = 302,
	MandatorManagement = 303,
	RepresentativeManagement = 304,
	CampaignManagement = 401,
	ReportManagement = 402,
	SalesProposal = 407,
	SalesOrder = 408,
	Protocols = 500,
	Monitoring = 501,
	BlackListManagement = 601,
	MandatorAccounting = 801,
	AccountingPeriodManagement = 802,
	VerticalEwl = 803,
	Reporting = 901,
	Dashboard = 902,
	RepresentativeAccounting = 1001,
	DiscountAnalysis = 1002,
	AgencyAccounting = 1101
}

export const enum DbPriceTypeId {
	None = 0,
	Cpm = 1,
	Flatrate = 2,
	Cpo = 4,
	Cpl = 8,
	Article = 16,
	Cpc = 64,
	Day = 128,
	Week = 256,
	Insert = 512,
	Issue = 1024,
	Address = 2048,
	Month = 4096,
	Seconds = 32768,
	Cpx = 65536,
	Cpi = 131072,
	Cpv = 262144,
	Cpapc = 1048576,
	Cpapv = 2097152,
	Cpapp = 4194304,
	Dcpm = 8388608,
	Qcpc = 16777216,
	Email = 33554432,
	Sms = 67108864,
	Vcpm = 134217728,
	Cpcov = 268435456,
	CPE = 1073741824,
	AvCPM = 536870912
}

export const enum DbPricingId {
	None = 0,
	PriceList = 1,
	FixedUnitPrice = 2,
	FixedPositionPrice = 3
}

export const enum DbOrganisationTypeIds {
	None = 0,
	Marketer = 1,
	Mandator = 2,
	Customer = 4,
	Advertiser = 8,
	Agency = 16,
	ParentAdvertiser = 32, //Konzern
	ParentAgency = 64, //Einkaufsgemeinschaft
	MainAgency = 128, //Hauptagentur
	Representative = 256
}

export const enum DbDiscountAgreementPropertyIds {
	None = 0,
	Standard = 1,
	NachVolumenerwartungRabattieren = 2,
	CpcFlightsAllowed = 8,
	LowCpmFlightsAllowed = 16,
	NotAssignable = 32,
	IsTemporary = 64,
	AdvertiserRequired = 1048576,
	ParentAdvertiserRequired = 2097152,
	AgencyRequired = 4194304,
	ParentAgencyRequired = 8388608,
	NoNetValuesInSalesProposal = 33554432
}

export const enum DbServerType {
	None = 0,
	Manuell = 2,
	Dart = 4,
	Dima = 8,
	Smart = 32,
	DartEnterprise = 128,
	Karbon = 256,
	Adtech = 512,
	Smartclip = 2048,
	AtvCool = 4096,
	Appnexus = 8192,
	Adition = 16384,
	FreeWheel = 32768,
	Adswizz = 65536,
	Cflight = 131072,
	One2Many = 262144,
}
export const enum AdvertisingTypeAdServerTypeTemplateName {
	Manuell = "manualTemplate",
	Dart = "dfpTemplate",
	Adition = "aditionTemplate",
	Appnexus = "appNexusTemplate",
	Smart = "smartTemplate",
	AdTech = "adTechTemplate",
	Smartclip = "smartclipTemplate",
	Karbon = "karbonTemplate",
	FreeWheel = "freewheelTemplate",
	Adswizz = "adswizzTemplate",
	One2Many = "one2manyTemplate"
}

export enum SqafSystemId {
	None = 0,
	Sqaf = 1,
	Self = 2,
	Dart = 32,
	OrangeDirect = 64,
	Smart = 128,
	Karbon = 512,
	Salesforce = 512,
	AdTech = 4096,
	Dwh = 16384,
	Adsales = 32768,
	SmartClip = 65536,
	AdserverKarbon = 262144,
	AdserverAppnexus = 524288,
	DBCFM = 33554432,
}
export enum AccountingClassification {
	Interior = 100,
	EuCountry = 110,
	NonEuCountry = 120
}

export enum DocumentSetIds {
	DebitorDocument = 1,
	IntSettlementDocument = 2,
	RevenueVoucher = 4,
	CommissionInvoice = 8
}

export enum DocumentTypeIds {
	None = 0,
	Inquiry = 1,
	SalesProposal = 2,
	OrderConfirmation = 4,
	Invoice = 32,
	AdjustmentVoucher = 64,
	PerformanceAdjusting = 128,
	DiscountAdjusting = 256,
	AgencyKickbackVoucher = 512,
	MandatorCreditVoucher = 1024,
	MandatorTurnover = 2048,
	DemandNote1 = 4096,
	DemandNote2 = 8192,
	DemandNote3 = 16384,
	MandatorCommissionInvoice = 32768,
	MandatorRevenueVoucher = 65536,
	InternalInvoice = 131072,
	MandatorSingleCommissionInvoice = 262144,
	SalesRepresentativeCommissionVoucher = 524288,
	VerticalEwlVoucher = 1048576,
	MandatorManualDocument = 2097152,
	MandatorDocument = 3509248,
	PerformanceOverview = 268435456,
	CancellationConfirmation = 1073741824,
	SalesProposalMediaPartner = 2147483648,
	OrderConfirmationMediaPartner = 4294967296,
	Amendment = 8589934592
}

export const enum DbPeriodTypeId {
	Days = 1,
	Weeks = 2,
	Months = 4,
	Years = 8
}

export const enum DbRemarkContext {
	SalesProposal = 1,
	OrderConfirmation = 2,
	MandatorAccountingDocs = 8,
	AdServder = 16,
	Internal = 32,
	CustomerAccountingDocs = 64,
	CustomerAccountingGui = 128,
	MandatorAccountingGui = 256,
	InternalSales = 512,
	InternalCampaignManagement = 1024,
	DBCFMLineItemTargeting = 34359738368
}

export enum DbCommercialSiteTypeId {
	None = 0,
	Nonadserved = 1,
	DfpSiteCombi = 2,
	DfpRotation = 3,
	SmartSiteCombi = 4,
	DartEnterpriseSite = 5,
	AdtechSiteCombi = 7,
	AdtechRotation = 8,
	AppnexusSiteCombi = 24,
	AppnexusRotation = 25,
	SmartclipRotation = 12,
	SmartclipSiteCombi = 11,
	KarbonRotation = 21,
	AditionRotation = 27,
	FreeWheelSiteCombi = 28,
	FreeWheelRotation = 29,
	AdswizzSiteCombi = 30,
	AdswizzSiteRotation = 31,
	CflightSiteCombi = 32,
	CflightSiteRotation = 33,
}

export enum DbServerInstancePropertyIds {
	None = 0,
	ManualDelivery = 1,
	SupportsTechnicalSites = 2,
	Prohibited = 4,
	SupportsAutoDelivery = 8
}

export enum DbCampaignRelationTypeId {
	None = 0,
	RequestToSalesProposal = 100,
	SalesProposalToOrder = 200
}

export enum DbAppNexusRoadblockType {
	None = 0,
	Normal = 1,
	Partiell = 2,
	Exakt = 3
}

export enum DbCustomerToCampaignConfig {
	// incomplete
	SalesProposalBookingAgency = 10, // Buchende Agentur
	SalesProposalPlanningAgency = 15, // Planende Agentur
	SalesProposalMainAgency = 20, // Hauptagentur
	SalesProposalParentAgency = 25, // Einkaufsgemeinschaft
	SalesProposalAdvertiser = 30, // Werbetreibender
	SalesProposalParentAdvertiser = 35, // Konzern
	SalesProposalAccountingAgency = 40, // Abbrechneende Agentur
	SalesProposalRepresentativeAgency = 46,
	SalesProposalRepresentativeAdvertiser = 47,
	SalesOrderBookingAgency = 50,
	SalesOrderPlanningAgency = 55,
	SalesOrderMainAgency = 60,
	SalesOrderParentAgency = 65,
	SalesOrderAdvertiser = 70,
	SalesOrderParentAdvertiser = 75,
	SalesOrderAccountingAgency = 80,
	SalesOrderRepresentativeAgency = 86,
	SalesOrderRepresentativeAdvertiser = 87,
	SalesProposalDealPartnerAgency = 90,
	SalesProposalDealPartnerAdvertiser = 91,
	SalesOrderDealPartnerAgency = 95,
	SalesOrderDealPartnerAdvertiser = 96,
}

export enum NautilusModuleId {
	None = 0,
	Test = -1,
	Nemo = 20,
	UserManagement = 101,
	PermissionManagement = 102,
	InventoryManagement = 201,
	AdvertisingTypeManagement = 202,
	PriceListManagement = 203,
	OrganisationManagement = 301,
	MarketerManagement = 302,
	MandatorManagement = 303,
	RepresentativeManagement = 304,
	CampaignManagement = 401,
	ReportManagement = 402,
	CampaignMonitor = 405,
	DfpTeams = 406,
	CampaignDeliveryImport = 1220,
	ProtocolBrowser = 500,
	BlacklistManagement = 601,
	MandatorAccounting = 801,
	AccountingPeriods = 802,
	VerticalEWL = 803,
	Reporting = 901,
	Dashboard = 902,
	Cube = 903,
	RepresentativeAccounting = 1001,
	AgencyAccounting = 1101,
	TechnicalSites = 1110,
	UserTaskManagement = 1103,
	CustomerAccounting = 1120
}

// sales.vsTreeTargetingRoot
export const enum DbTreeTargetingRoot {
	DfpGeoTargeting = 101,
	DfpDeviceTargeting = 102,
	DfpConnectionTargeting = 103,
	KarbonGeoTargeting = 301,
	SmartclipGeoTargeting = 401,
	SmartclipTechTargeting = 402,
	AppnexusGeoTargeting = 501,
	AppnexusSystemTargeting = 502,
	AditionGeoTargeting = 601,
	FreeWheelGeoTargeting = 701
}

export const enum SqafFieldPropertyIds {
	None = 0,
	/** Ownership (FP_OWNERSHIP) Das Attribut kennzeichnet den Eigner eines Objekt */
	Ownership = 2,
	/** Counter (FP_COUNTER) Über sqaf.pCounter_GetNext erzeugter Wert bzw. mit Sequenz assoziert. */
	Counter = 8,
	/** Volatile (FP_VOLATILE) Das Attribut wird extern (Trigger o.ä) verändert */
	Volatile = 256,
	/** Computed (FP_COMPUTED) Berechnetes Attribut */
	Computed = 512,
	/** Hidden (FP_HIDDEN) Im GUI nicht sichtbares Attribut */
	Hidden = 1024,
	/** Not Selectable (FP_NO_SELECT) Attribut wird nicht in der Spaltenliste einer select Anweisung aufgeführt */
	NoSelect = 2048,
	/** Object Id (FP_OBJECT_ID) Das Attribut ist ein Objekt Identifizierer. */
	ObjectId = 4096,
	/** Archive (FP_ARCHIVE) Das Attribut ist Archiv-Bit, d.h. Daten dieser Zeile können nicht mehr zugewiesen werden */
	Archive = 8192,
	/** Class Id (FP_CLASS_ID) ID der Datenbank Klassen des Objektes. */
	ClassId = 16384,
	/** Grouped (FP_GROUPED) Kennzeichen für ein gruppiertes Attribut (Class Id, Object Id) */
	Grouped = 32768,
	/** Standard (FP_STANDARD) Kennzeichen für Standardwerte in einem Wertebereich. */
	Standard = 65536,
	/** Invisible (FP_INVISIBLE) Im GUI initial nicht sichtbares Attribut */
	Invisible = 131072,
	/** Transient (FP_TRANSIENT) Das Attribut ist nur im Client und nicht auf der Datenbank vorhanden */
	Transient = 262144,
	/** Monitored (FP_MONITORED) Beobachtetes Feld, Änderungen an diesen Attributen werden historisiert */
	Monitored = 524288,
	/** ReadOnly (FP_READONLY) Das Attribut ist Schreibgeschützt */
	Readonly = 1048576,
	/** Required (FP_REQUIRED) Eingabe ist erforderlich */
	Required = 2097152,
	/** Valueset (FP_VALUESET) Das Attribut ist ein referenzierte einen Eintrag in einem Wertebereich. */
	Valueset = 4194304,
	/** Update Caption (FP_UPDATE_CAPTION) Die Caption im GUI wird durch FI_CAPTION bestimmt */
	UpdateCaption = 8388608,
	/** Number (FP_NUMBER) Benutzerfreundliche Nummer des Datensatzes (z.B. Fremdnummer) */
	Number = 16777216,
	/** Conditionally ReadOnly (FP_CONDITIONAL_READONLY) Das Attribut ist unter gewissen Bedingungen schreibgeschützt */
	ConditionalReadonly = 33554432,
	/** Conditionally Required (FP_CONDITIONAL_REQUIRED) Für das Attribut ist unter gewissen Bedingungen die Eingabe erforderlich. */
	ConditionalRequired = 67108864,
	/** Conditional Hidden (FP_CONDITIONAL_HIDDEN) Das Attribut ist kontextabhängig nicht sichtbar */
	ConditionalHidden = 134217728,
}

export enum PriceListPropertyIds {
	None = 0,
	Overwritable = 4
}

export enum DbPaymentPlayIds {
	ManuellIw = 110,
	SollwerteManuell = 111,
	NachschussPeriodeIw = 120,
	KeineRechnungIw = 150,
	KeineRechnungSw = 160,
	GesamtVorschussSw = 170,
	GesamtNachschussIw = 180,
	MonatlichSw = 190,
	MonatlichIw = 200,
	GesamtNachschussSw = 210,
	NachschussMonatSw = 220,
}

export enum DbPaymentTermId {
	Unbekannt = 1
}

export enum DbUserContactTypeIds {
	None = 0,
	MailBusiness = 1,
	MailAdAlliance = 512
}

export enum RateTypeIds {
	None = 0,
	PrimaryDividedBySecondary = 1,
	SecondaryDividedByPrimary = 2
}

export enum ResolutionTypeIds {
	None = 0,
	Common = 1,
	Publisher = 2,
	TechnicalSite = 4,
	CommercialSite = 8
}

export enum DbQueueProcessingStatusId {
	InPreparation = -1,
	Pending = 0,
	Processing = 1,
	Canceled = 2,
	Completed = 3,
	NotFound = 100
}

export enum DbQueueOperationResultStatusId {
	Undefined = 0,
	Successful = 1,
	Faulty = 2,
}

export enum DbAccountingAdjustmentProcedure {
	None = 0,
	InvoiceCancelation = 1,
	OrderBasedAdjusting = 2,
	DebtorBasedAdjusting = 3
}

export enum DbCampaignTypeId {
	None = 0,
	SalesRequest = 1, /// Anfrage
	SalesProposal = 2, /// Angebot
	SalesOrder = 4, /// Auftrag
	ProgrammaticProposal = 32, // Programmatic Angebot
	ProgrammaticOrder = 64 // Programmatic Auftrag
}

export enum ObjectLinkCategory {
	Default = 0,
	Copy = 1,
	All = 1
}